<template>
    <div class="content-table">
        <el-table :data="tableData" style="width: 100%" stripe empty-text=" ">
            <el-table-column prop="name" :label="$t('distributor.name')" width="150" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span style="cursor: pointer; color: #1478F6;" @click="goLogin">{{ scope.row.name }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="code" :label="$t('distributor.code')" width="150" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="adminUser" :label="$t('distributor.username')" width="150" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="createTime" :label="$t('distributor.startdate')" width="150">

                <template slot-scope="scope">
                    {{ $moment(scope.row.createTime).format("DD/MM/YYYY") }}
                </template>
            </el-table-column>
            <el-table-column prop="licenses[0].expireTime" :label="$t('distributor.enddate')" width="150">

                <template slot-scope="scope">
                    {{ scope.row.licenses.length > 0 ? $moment(scope.row.licenses[0].expireTime).format("DD/MM/YYYY") : '' }}
                </template>
            </el-table-column>
            <el-table-column prop="licenses[0].authorizedChannelCount" :label="$t('distributor.licenses')" width="150">
            </el-table-column>
            <el-table-column prop="licenseType" :label="$t('distributor.licensestype')" width="150">

                <template slot-scope="scope">
                    {{scope.row.licenses.length > 0 && scope.row.licenses[0].licenseType === 1 ? $t('distributor.local') : $t('distributor.cloud') }}
                </template>
            </el-table-column>
            <el-table-column prop="licenses[0].enableChannelCount" :label="$t('distributor.activechannels')" width="150">
            </el-table-column>
            <el-table-column prop="licenses[0].status" :label="$t('distributor.status')" width="150">

                <template slot-scope="scope">
                    <img src="../../../assets/icon/active-1.png" style="width:20px;" v-if="scope.row.licenses.length > 0 && scope.row.licenses[0].status" />
                    <img src="../../../assets/icon/active-0.png" style="width:20px;" v-else />
                </template>
            </el-table-column>
            <el-table-column :label="$t('common.action')" fixed="right" width="150">

                <template slot-scope="scope">
                    <span class="blue-txt" @click="clickEdit(scope.row, 'distributorDetail')"
                        style="margin-right: 10px;">{{
            $t('common.details') }}</span>
                    <span class="blue-txt" @click="clickEdit(scope.row, 'distributorEdit')">{{
                        $t('common.edit') }}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    props: {
        tableData: {
            type: Array, default: () => ([])
        },
    },
    methods: {
        clickEdit(row, name) {
            this.$router.push({ name, params: { id: row.id } })
        },
        goLogin() {
            window.open(`${location.origin}/#/login`)
        }
    }
}
</script>